import { AppDetailsState } from '../../slices/appDetails';
import type { Quote } from '../../slices/quote';
import { TaxIndicator } from '../../types/enums';
import type { CustomerParty, RiskLocation } from '../../types/policy';
import type { Nullable } from '../../types/utils';
import type { EnhancedExtraInfo } from '../index';

function getIntermediaryCode(appDetails: AppDetailsState): string {
  const group = appDetails.groups?.find((g) => g !== 'staff');
  return group ? group.toUpperCase() : 'DIGISME';
}

export const getCustomerParty = ({
  extraInfo,
  quote,
  businessLocation,
  includeAccessToken,
  appDetails,
}: {
  extraInfo: Nullable<EnhancedExtraInfo>;
  includeAccessToken: boolean;
  businessLocation: RiskLocation;
  quote: Nullable<Quote>;
  appDetails: AppDetailsState;
}): CustomerParty => ({
  orgName: extraInfo.businessName ?? '',
  ...(extraInfo.abn && { orgABN: extraInfo.abn }),
  businessName: extraInfo.businessName ?? '',
  ...((extraInfo.email || extraInfo.mobile) && {
    contact: {
      ...(extraInfo.email && { primaryEmailAddress: extraInfo.email }),
      ...(extraInfo.mobile && { mobilePhoneNumber: extraInfo.mobile }),
    },
  }),
  ...(includeAccessToken && quote.accessToken && { accessToken: quote.accessToken }),
  location: { ...businessLocation },
  firstName: extraInfo.firstName ?? '',
  lastName: extraInfo.lastName ?? '',
  taxIndicator: TaxIndicator.Unknown,
  clientIdMemberNo: extraInfo.partnerMembershipNumber ?? '',
  intermediaryCode: getIntermediaryCode(appDetails),
});
